var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5072 15.3803C16.7608 15.8779 15.8938 16.1409 15 16.1409C14.1062 16.1409 13.2393 15.8779 12.4929 15.3803L0.199746 7.18465C0.131883 7.13928 0.065276 7.09205 0 7.04303L0 20.4725C0 22.0123 1.24951 23.2342 2.7617 23.2342H27.2382C28.778 23.2342 29.9999 21.9847 29.9999 20.4725V7.04297C29.9346 7.09212 29.8678 7.13945 29.7998 7.18488L17.5072 15.3803Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17481 5.72219L13.468 13.9179C13.9333 14.2282 14.4666 14.3833 14.9999 14.3833C15.5333 14.3833 16.0667 14.2281 16.5321 13.9179L28.8252 5.72219C29.5608 5.23205 30 4.41174 30 3.52639C30 2.00406 28.7615 0.765625 27.2392 0.765625H2.76076C1.2385 0.765684 1.45319e-06 2.00412 1.45319e-06 3.52785C-0.00045491 3.96215 0.106584 4.38981 0.311571 4.7727C0.516557 5.15558 0.813119 5.48177 1.17481 5.72219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.f42ad57d2a4fdb593235db2189d7157d.svg";
export { ForwardRef as ReactComponent };